// @flow
import types from './verandaCalculatorConstants';
import { getAsync, postAsync } from '../../../_metronic/helpers/httpClient';

// Action to clear the calculator state in Redux
export const clearCalculatorState = () => async dispatch => {
    dispatch({
        type: types.CLEAR_STATE
    });
};

// Action to reset the calculator inputs/results (might clear specific parts of state)
export const resetCalculator = () => async dispatch => {
    dispatch({
        type: types.RESET_CALCULATOR
    });
};

export const calculateVeranda = (calculatorData) => async (dispatch) => {
    dispatch({ type: types.CALCULATE_VERANDA });

    const response = await postAsync('/orders/calculate-veranda', calculatorData);

    if (response.isSuccess) {
        dispatch({
            type: types.CALCULATE_VERANDA_SUCCESS,
            payload: response
        });
        return response;
    } else {
        dispatch({
            type: types.CALCULATE_VERANDA_FAILURE,
            payload: response
        });
        // throw response;
    }
};

 export const calculateVeranda2 = (calculatorData) => async (dispatch) => {
     dispatch({ type: types.CALCULATE_VERANDA });

     // Simulate API call delay (e.g., 500ms)
     await new Promise(resolve => setTimeout(resolve, 500));

    try {
        // *** MOCK RESPONSE ***
        // Create a fake successful response mimicking the structure
        // your real API might return (and what the reducer expects).
        const fakeApiResponse = {
            isSuccess: true,
            data: {
                // Populate materialsList based on the example image
                materialsList: [
                    { material: 'Goot', size: '500', count: 1, gemaakt: '', afgenomen: '' },
                    { material: 'Muurplaat', size: '500', count: 1, gemaakt: '', afgenomen: '' },
                    { material: 'Zij Ligger', size: '186', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Middel Ligger', size: '186', count: 4, gemaakt: '', afgenomen: '' }, // Example: Count adjusted based on input (pretend logic)
                    { material: 'Zij Deksel', size: '193', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Middel Deksel', size: '193', count: 4, gemaakt: '', afgenomen: '' }, // Example: Count adjusted based on input (pretend logic)
                    { material: 'Sierklick', size: '92,8', count: 10, gemaakt: '', afgenomen: '' }, // Example: Count adjusted based on input (pretend logic)
                    { material: 'Polycarbon', size: '96,6 x 193', count: 5, gemaakt: '', afgenomen: '' }, // Example: Count adjusted based on input (pretend logic)
                    { material: 'Staander', size: '250', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Staanderkap', size: '250', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Muurplaat rubber', size: '500', count: 1, gemaakt: '', afgenomen: '' },
                    { material: 'Goot deksel', size: '', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Muurplaat deksel', size: '', count: 2, gemaakt: '', afgenomen: '' },
                    { material: 'Bladvanger', size: '', count: 1, gemaakt: '', afgenomen: '' },
                    { material: 'Bouwpakket', size: '', count: 1, gemaakt: '', afgenomen: '' },
                    // Add more items or adjust counts based on calculatorData if needed for more realistic mocking
                ],
                // You could add other calculated values here if needed
                // calculatedWidth: calculatorData.breedte,
                // calculatedProjection: calculatorData.uitval,
            },
            message: 'Calculation successful (Mock)', // Optional message
        };
        // *** END OF MOCK RESPONSE ***

        dispatch({
            type: types.CALCULATE_VERANDA_SUCCESS,
            payload: fakeApiResponse // Pass the fake response to the reducer
        });
        return fakeApiResponse; // Return response for potential further handling in component

    } catch (error) {
        // Although unlikely in this mock, keep error handling structure
        console.error("Mock calculation error:", error);
        const errorResponse = {
            isSuccess: false,
            message: 'Mock calculation failed',
            error: error // Include actual error if one occurs
        };
        dispatch({
            type: types.CALCULATE_VERANDA_FAILURE,
            payload: errorResponse
        });
        throw errorResponse; // Throw error for handling in component if needed
    }
};
